<template>
    <div class="phoneAboutUs">
        <div style="height: 5.29em;width:100%;position: fixed;left: 0;z-index: 10000;
        top: 0;background-color:#fff;" class="flex flex-a-c">
            <img src="../assets/img/logo.png" style="width: 8.33em;height: 1.96em;margin-left: 2.04em;" alt="">
        </div>
        <div style="height: 5.29em;"></div>
        <img src="../assets/img/phone-about-us.jpg" width="100%" alt="">
        <div class="" style="padding: 0 1em 100px;">
            <div></div>
            <div class="flex flex-j-c">
                <img src="../assets/img/guanyuwomen.jpg"
                     style="width: 24em;height:12.8em;margin-top: 2.2em;" alt="">
            </div>
            <div class="font-600 text-center" style="line-height: 2em;">
                <div class="font-18" style="margin-top: 2.2em;">诚信为本 质量至上</div>
                <div class="lh-2" style="margin-top: 2.2em;">以自己的品牌特色和优势促进我国IVD产业质量提升、成本降低，</div>
                <div class="lh-2">增强我国核心原料产品的市场竞争力</div>
            </div>
            <div class="mt-8" v-html="about.content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'aboutUs',
        props: {},
        data() {
            return {
                about: {}
            }
        },
        async mounted() {
            this.getAbout()
        },
        methods: {
            async getAbout() {
                this.about = await this.$api.getAbout()
            },

        },

    }
</script>
<style scoped lang="scss">
    .phoneAboutUs {
        height: 100px;
        width: 100%;
        font-size: 12px;

    }

    /deep/ img {
        max-width: 100%;
    }

    /deep/ .swiper-pagination-bullet {
        height: .7em;
        width: .7em;
    }
</style>
